import { ValueInput } from '@utils/formattersV2';
import {
  chartColors,
  unifiedPlatformColorPalette,
} from '@utils/unifiedPlatformColorPalette';

export type RslWaterfallChartProps = {
  yAxisTitle?: string;
  yAxisFormatter: (value: ValueInput) => string;
  valueFormatter: (value: ValueInput) => string;
  data: {
    name: string;
    value: number;
    dataLabelValue?: number;
  }[];
};

export const rslWaterfallChartOptions = (
  props: RslWaterfallChartProps
): Highcharts.Options => ({
  credits: {
    enabled: false,
  },
  exporting: {
    enabled: false,
  },
  legend: {
    enabled: false,
  },
  title: {
    text: undefined,
  },
  tooltip: {
    enabled: false,
  },
  xAxis: {
    type: 'category',
  },
  yAxis: {
    labels: {
      formatter() {
        return props.yAxisFormatter(Number(this.value));
      },
    },
    title: {
      text: props.yAxisTitle,
    },
  },
  series: [
    {
      type: 'waterfall',
      name: props.yAxisTitle,
      data: props.data.map((point, index) => ({
        y: point.value,
        name: point.name,
        isSum: index === props.data.length - 1,
      })),
      colorByPoint: true,
      borderWidth: 0,
      borderRadius: 5,
      dataLabels: {
        enabled: true,
        style: {
          textOutline: 'none',
          color: unifiedPlatformColorPalette.black,
        },
        formatter() {
          const dataLabelValue =
            props.data[this.index].dataLabelValue ?? this.y;
          return props.valueFormatter(dataLabelValue);
        },
      },
      colors: chartColors,
    },
  ],
});
